module.exports = __webpack_public_path__ + "img/checkbox_checked_24.138c6faf.svg";